<lgb-header-gradient [height]="200"></lgb-header-gradient>
<div class="screen-container gradient" [loading]="loading()">
	@if(cardBinder()){
		<div class="hero-card rounded-box">
			<img wSkeleton="100%" hSkeleton="500px" class="img-card" [src]="binderS.getImgInventory(cardBinder().img)"/>
			@if(admin()){
				<div class="card-container">
					<!-- favoris -->
					<div class="fav-container">
						@if(!backHisto()){
							<a [routerLink]="getUrlBack()" [fragment]="getFragmentBack()" [queryParams]="getQueryParamsBack()" class="back add-fav glass rounded-full bg-black/40">
								<i class="fa-regular fa-chevron-left"></i>
							</a>
						}
						@else{
							<a [routerLink]="router.getPrevious({active: 'cards'}, cardBinder().ident)" class="back add-fav glass rounded-full bg-black/40">
								<i class="fa-regular fa-chevron-left"></i>
							</a>
						}
						<div class="share-container">
							<a (click)="toggleFavoriteCard()" class="add-fav glass rounded-full bg-black/40 mb-3">
								<i [ngClass]="{'fa-solid': cardBinder()?.isFavorite, 'fa-light': !cardBinder()?.isFavorite}" class="fa-light fa-bookmark"></i>
							</a>
							<lgb-share [element]="cardBinder()" typeElement="card">
						   		<span class="add-fav glass rounded-full bg-black/40 mb-2">
						   			<i class="fa-light fa-paper-plane"></i>
							    </span>
							</lgb-share>
						</div>
					</div>
				</div>
			}
		</div>
		@if(admin()){
			<a href="#" [routerLink]="router.parse('collect-edit-card', [cardBinder().ident])" class="refresh-card btn btn-link mb-4">
				<i class="fa-regular fa-pen"></i> Modifier la carte
			</a>
		}

		<!-- extension -->
		<img class="img-card-set mb-4" [altImg]="cardS.getLogos(cardSet().logo, true)"/>
		<div class="ext-container">
			<p class="title-sticky title-xs font-serra name-card">{{name()?.text}}</p>
			<div class="summary-item">
				<!-- numéro -->
				<div class="mt-2">
					<i class="badge badge-soft badge-primary fa-regular fa-hashtag mr-2"></i> {{card().numero}}
				</div>

				<!-- rareté -->
				<div class="mt-2">
					<i class="badge badge-soft badge-primary fa-regular fa-stars ml-6 mr-2"></i> {{getRarity().name}}
				</div>

				<!-- date de sortie de la carte = extension -->
				<div class="mt-2">
					<i class="badge badge-soft badge-primary fa-light fa-calendar-days ml-6 mr-2"></i> {{cardSet().releaseDate | date:'dd/MM/yyyy'}}
				</div>
			</div>
		</div>

		<p class="title-sticky title-xs font-serra mt-4">Coup d'oeil</p>
		<div class="overview-container mb-4">
			<!-- langue -->
			<div class="overview-item">
	    		<span class="img-lang badge badge-soft badge-primary">
	    			<img src="img/skin/flag-{{cardBinder().lang}}.svg"/>
	    		</span>
	    		{{cardBinder().lang | uppercase}}
			</div>

			<!-- Etat -->
			<div class="overview-item-cond">
	    		<lgb-rate [rate]="cond().ref | valCondition"></lgb-rate>
				<span class="text-xs tracking-wide condition">
		    		{{cond().name}}
		    	</span>

			</div>

			<!-- Variante -->
			<div class="overview-item">
				<i class="badge badge-soft badge-primary fa-regular fa-tags"></i> 
					@if(variante()){
						{{variante().name | uppercase}} 
					}
					@else{
						-
					}
			</div>

			<!-- valeur  -->
			<div class="overview-item">
				<i class="badge badge-soft badge-primary fa-regular fa-piggy-bank"></i>
				@if(cardBinder().amount){
					{{cardBinder().amount | number:'1.0-0':'fr-FR'}}€
				}
				@else{
					-
				}
			</div>
		</div>

		<!-- prix des marketplaces -->
		<p class="title-sticky title-xs font-serra mt-4 mb-2">Estimation de la carte</p>
		<div class="price-container">
			@for(market of markets(); track market.ref){
			  <label class="input mb-2">
			  	<div class="label">
				    <img [src]="market | imgMarketPlace"/>
				</div>
				<span class="price-number">
					@let p=priceMarket(market);
					@if(p){
						{{p | number:'1.0-2':'fr-FR'}}
					}
					@else{
						NC
					}
				</span>
				<div class="label card-euro">
				  	<i class="fa-regular fa-euro-sign"></i>
				</div>
			  </label>
			}
		</div>

		@if(admin()){
			<div [loading]="loadingPrice()">
				@if(!prices()){
					<div class="detail-container">
						<button (click)="loadPrice()" class="text-xs btn text-primary">
							<!-- <i class="fa-solid fa-chart-column"></i>Détail de l’estimation -->
							<i class="fa-sharp fa-solid fa-chart-mixed"></i>Détail de l’estimation
						</button>
					</div>
				}
				@else{
					<lgb-prices-grid [prices]="prices()"></lgb-prices-grid>
				}
			</div>
		}

		@if(admin()){
			<p class="title-sticky title-xs font-serra mt-2">Dans la collection</p>
			<ul #searchable="searchable" [qSearch]="null" [search]="search()" [(results)]="inventoryPage" [length]="length" class="list bg-base-100 rounded-box shadow-md mb-4">

			  @if(inventory().length){
		  	  	<li class="p-4 pb-2 opacity-60 tracking-wide">Liste des exemplaires de cette carte</li>		  	
			  }
			  @else{
		  	  	<li class="p-4 pb-2 opacity-60 tracking-wide">Aucun exemplaire de cette carte</li>		  	
			  }
			  
			  @for(card of inventoryPage(); track card.ident){
				  <li class="list-row">
				    <div>
				    	<img class="size-10" [src]="binderS.getImgInventory(card.img)"/>
				    </div>
				    <div>
				      <div class="capitalize">{{card.lang}} - {{getCondition(card.condition).name}}</div>
				      <div class="text-xs capitalize font-semibold opacity-60">
				      	@if(card.binder){
				      		Binder #{{card.binder}}
				      	}
				      	@else{
				      		Binder sans code
				      	}
				      </div>
				    </div>
				    @if(card.ident!=cardBinder().ident){
					    <a href="#" [routerLink]="router.parse('collect-card', [card.ident])" class="btn btn-square btn-ghost text-primary">
							<i class="fa-light fa-eyes"></i>
							<!-- <i class="fa-regular fa-arrow-right-from-bracket"></i> -->
					    </a>
					}
				  </li>
			  }
			</ul>
			@if(inventory().length){
				<div class="pagination mt-4">
					<div class="join">
					  @if(searchable.canPrev()){
				  	  	<button (click)="searchable.prev()" class="join-item btn">«</button>
				  	  }
					  <button class="join-item btn">Page {{searchable.page()+1}}</button>
					  @if((searchable.page()+1)*length < inventory().length){
					  	<button (click)="searchable.next()" class="join-item btn">»</button>
					  }
					</div>
				</div>
			}

			<div class="icon-share-container mb-4">
				<!-- sms -->
				<lgb-share [element]="cardBinder()" typeElement="card" typeShare="sms">
					<span class="btn btn-circle bg-[#03C755] border-[#00b544] mx-2">
						<i class=" fa-solid fa-comment"></i>
					</span>
				</lgb-share>

				<!-- messenger -->
				<lgb-share [element]="cardBinder()" typeElement="card" typeShare="messenger">
					<span class="btn btn-circle bg-[#1A77F2] border-[#005fd8] mx-2">
						<i class="fa-brands fa-facebook-messenger"></i>
					</span>
				</lgb-share>

				<!-- insta -->
				<lgb-share [element]="cardBinder()" typeElement="card">
					<span class="btn btn-circle bg-[#C13584] border-[#C13584] mx-2">
						<i class="fa-brands fa-instagram"></i>
					</span>
				</lgb-share>

				<!-- mail -->
				<lgb-share [element]="cardBinder()" typeElement="card" typeShare="mail">
					<span class="btn btn-circle bg-[#1A77F2] border-[#005fd8] mx-2">
						<i class="fa-solid fa-envelope"></i>
					</span>
				</lgb-share>
			</div>

			<button (click)="rmCard()" class="btn-removed btn btn-outline btn-error my-4">Retirer du binder</button>
		}
	}

	@if(!admin()){
		<lgb-cta-share></lgb-cta-share>
	}
</div>